import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useConfigQuery } from '@modules/config/queries';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { useTokensQuery } from '@modules/tokens/queries';

import type {
  ITranslationsKeyMap,
} from '../types';
import {
  I18N_GET_TRANSLATIONS_QUERY_KEY,
  I18N_GET_TRANSLATIONS_URL,
} from '../constants';

export default function useI18nQuery(language: Ref<string | undefined>): IContextQueryResult<ITranslationsKeyMap, Error> {
  const { isSuccess: enabledToken } = useTokensQuery();
  const { isSuccess: enabledConfig } = useConfigQuery();
  const { fetchGet } = useRestClient();

  return useContextQuery<ITranslationsKeyMap, Error>({
    queryKey: [I18N_GET_TRANSLATIONS_QUERY_KEY, language],
    queryFn: ({ signal }) => fetchGet(I18N_GET_TRANSLATIONS_URL, {
      signal,
      queryParams: { language: language.value },
      isEssential: true,
    }),
    gcTime: Infinity,
    staleTime: Infinity,
    refetchOnMount: false,
    enabled: computed(() => enabledToken.value && enabledConfig.value && !!language.value),
  });
}
